export const DEBUG_PANEL_STORAGE_KEY = 'gamification.debugPanel'
export const DEBUG_PANEL_DISABLED_VALUE = 'disabled'
export const CONSOLE_BUFFER_MAX = 50
